export const enum MyAccountToggleSaveButtonActionEvent {
  /**
   * Sync with the store
   */
  sync = 'sync',
}
